module.exports = __webpack_public_path__ + "static/media/mug-marshmallows.801df9e7.svg";